
    /**
    * Linear interpolation.
    * IMPORTANT:will return `Infinity` if numbers overflow Number.MAX_VALUE
    */
    function lerp(ratio, start, end){
        return start + (end - start) * ratio;
    }

    module.exports = lerp;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/math/lerp.js
// module id = 550
// module chunks = 0